import React, { useState } from "react";
import RefreshCircle from "../../assets/svgIcons/RefreshCircle";
import StyledText from "./StyledText";

const StyledReload = ({ onChange }) => {
  const [reload, setReload] = useState(0);
  const onReloadIcon = (event) => {
    if (onChange) {
      setReload(reload + 360);
      onChange(event);
    }
  };
  return (
    <StyledText
      color="danger"
      className="cursor-pointer"
      onClick={onReloadIcon}
      style={{
        transform: `rotate(${reload}deg)`,
        transition: "transform 1s ease",
        marginTop: "-1px",
      }}
    >
      <RefreshCircle />
    </StyledText>
  );
};

export default StyledReload;
